export default "__VITE_ASSET__BNPKzFse__"